import cn from "classnames";

import styles from "./ButtonGroup.module.scss";
import { Button } from "shared/ui/components/Button";

const ButtonGroup = ({ value, onChange, list, className, activeClassName, size = "medium" }: any) => (
  <div className={styles.wrapper}>
    {list.map((item, index) =>
      <Button
        onClick={() => onChange(item)}
        key={index}
        className={cn(
          styles.button,
          { [styles.buttonActive]: (typeof value === "object" ? value?.value === item?.value : value === item) },
          className,
          { [activeClassName]: (typeof value === "object" ? value?.value === item?.value : value === item) }
        )}
        variant="outline"
        size={size}
      >
        {item?.label || item}
      </Button>
    )}
  </div>
);

export default ButtonGroup;
